"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var friends = {
  id: "friends",
  title: {
    en: "Friend system",
    de: "Freunde-System"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Friend System"), /*#__PURE__*/_react.default.createElement("p", null, "To help strengthen the communities within the game, Ferentus provides a 'Find Friends' function."), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "Adding a Friend: Type '/friend [Name of the Character]' then press the 'Enter' key. This action will add the selected friend to your friends list.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, "Finding a Friend: Type '/friend' then press the 'Enter' key to activate your friend list. You can check who is and is not logged on."), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "Name of Friends: Displays name of friends"), /*#__PURE__*/_react.default.createElement("li", null, "Status: 'On' means the friend is on-line"), /*#__PURE__*/_react.default.createElement("li", null, "Whisper: Used to whisper to the friend"), /*#__PURE__*/_react.default.createElement("li", null, "Delete: Used to delete the friend from the list")))))
  }
};
var _default = friends;
exports.default = _default;